module.exports = __webpack_public_path__ + "img/img-deliver.4b3307ed.png";